<template>
  <app-confirm-dialog
    v-model="dialog"
    @confirm="confirm"
    @cancel="cancel"
    confirmBtnText="延長輔導"
    cancelBtnText="取消"
    maxWidth="320"
    :loading="loading"
    :showConfirmBtn="showConfirmBtn"
    :showCancelBtn="showCancelBtn">
    <span class="subheading">{{dialogText}}</span>
    <template slot="action">
      <v-btn
        v-show="showCancelInvtieBtn"
        @click="cancelInvite"
        flat>
        取消邀請
      </v-btn>
    </template>
  </app-confirm-dialog>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {FudaoEvent, fudaoAppService} from 'langyan';

const getDefaultData = () => {
  return {
    loading: false,
    dialog: false,
    dialogText: '是否要延長輔導?',
    showConfirmBtn: true,
    showCancelBtn: true,
    showCancelInvtieBtn: false
  };
};

export default {
  data: getDefaultData,
  computed: {
    ...mapState('fudao', {
      fudaoDto: state => state.fudaoDto,
      responseTimeout: state => state.responseTimeout
    })
  },

  watch: {
    dialog(value) {
      if (!value) {
        this.reset();
      }
    }
  },

  beforeDestory() {
    this.reset();
  },

  methods: {
    ...mapActions('alert', {
      addAlert: 'add'
    }),

    isDifferentFudao(domainEvent) {
      return this.fudaoDto.id && this.fudaoDto.id !== domainEvent.body.id;
    },

    open() {
      let extendAvaliable = fudaoAppService.canExtendFudao(this.fudaoDto.id);
      if (!extendAvaliable) {
        return;
      }
      this.dialog = true;
    },

    reset() {
      this.$eventBus.$off(FudaoEvent.TeacherExtendInvitationSent, this.onTeacherExtendInvitationSent);
      // this.$eventBus.$off(FudaoEvent.StudentExtendInvitationReceived, this.onStudentExtendInvitationReceived);
      this.$eventBus.$off(FudaoEvent.StudentExtendInvitationAccepted, this.onStudentExtendInvitationAccepted);
      this.$eventBus.$off(FudaoEvent.StudentExtendInvitationRejected, this.onStudentExtendInvitationRejected);
      this.$eventBus.$off(FudaoEvent.StudentExtendInvitationNoReponse, this.onStudentExtendInvitationNoReponse);
      this.$eventBus.$off(FudaoEvent.FudaoStartFailed, this.onFudaoStartFailed);

      clearTimeout(this._timeout);
      let data = getDefaultData();
      Object.keys(data).forEach(key => this[key] = data[key]);
    },

    async confirm() {
      this.loading = true;
      this.$eventBus.$on(FudaoEvent.TeacherExtendInvitationSent, this.onTeacherExtendInvitationSent);
      // this.$eventBus.$on(FudaoEvent.StudentExtendInvitationReceived, this.onStudentExtendInvitationReceived);
      this.$eventBus.$on(FudaoEvent.StudentExtendInvitationAccepted, this.onStudentExtendInvitationAccepted);
      this.$eventBus.$on(FudaoEvent.StudentExtendInvitationRejected, this.onStudentExtendInvitationRejected);
      this.$eventBus.$on(FudaoEvent.StudentExtendInvitationNoReponse, this.onStudentExtendInvitationNoReponse);
      this.$eventBus.$on(FudaoEvent.FudaoStartFailed, this.onFudaoStartFailed);

      await fudaoAppService.inviteExtendFudaoAsync(this.fudaoDto.id);

      this._timeout = setTimeout(() => {
        this.sentNoResponse();
      }, this.responseTimeout);
    },

    cancel() {
      this.dialog = false;
    },

    async cancelInvite() {
      clearTimeout(this._timeout);
      await fudaoAppService.cancelExtendFudaoInvition(this.fudaoDto.id);
      this.dialog = false;
    },

    sentNoResponse() {
      fudaoAppService.noResponseExtendFuadoAsync(this.fudaoDto.id);
    },

    // events -------------------------------------

    onTeacherExtendInvitationSent(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.dialogText = '已送出延長輔導邀請，等待對方回應...';
      this.showConfirmBtn = false;
      this.showCancelBtn = false;
      this.showCancelInvtieBtn = true;
    },

    // onStudentExtendInvitationReceived(domainEvent) {
    // },

    async onStudentExtendInvitationAccepted(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }

      clearTimeout(this._timeout);
      await fudaoAppService.extendFudaoAsync(this.fudaoDto.id);
      this.dialog = false;
    },

    onStudentExtendInvitationRejected(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'info', content: '學生拒絕延長輔導'});
      this.dialog = false;
    },

    onStudentExtendInvitationNoReponse(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'warning', content: '邀請延長輔導無回應'});
      this.dialog = false;
    },

    onFudaoStartFailed(errMsg) {
      this.addAlert({level: 'error', content: '邀請延長輔導發生錯誤: ' + errMsg});
    }
  }
};
</script>